<template>
  <section class="land-box">
    <div
      class="left-wrap"
      :style="constSide === 'left' ? { width: constSize } : { flex: 1 }"
    >
      <el-image
        class="land-image"
        :src="require('@/assets/images/auth-box-left.png')"
        fit="cover"
      >
      </el-image>
    </div>
    <div
      class="right-wrap"
      :style="constSide === 'right' ? { width: constSize } : { flex: 1 }"
    >
      <div class="auth-form-box">
        <div
          class="land-title-box ou-flex-col between"
          :class="[isRegPage ? 'compact-layout' : '']"
        >
          <div @click="goHomePage" class="land-title main-title ou-flex-center">
            <div class="land-logo ou-flex-center">
              <el-image
                class="land-image"
                :src="require('@/assets/images/land-logo.png')"
                fit="cover"
              >
              </el-image>
            </div>
            <div class="text-main">开放云书院</div>
          </div>
        </div>
        <slot name="main" />
        <slot name="foot" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LandBox",
  props: {
    url: { type: String, default: "@/assets/images/auth-box-left.png" },
    constSide: {
      type: String,
      default: "left",
      validator: (v) => ["left", "right"].includes(v),
    },
    constSize: { type: String, default: "47.12%" },
    isRegPage: { type: Boolean, default: false },
    isFindPage: { type: Boolean, default: false },
    subTitle: { type: String, default: "" },
  },
  data() {
    return {};
  },
  components: {},
  watch: {},
  mounted() {},
  methods: {
    goHomePage() {
      this.$router.push("/index");
    },
  },
};
</script>
<style scoped lang="scss">
.land-box {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 20px;
  height: 76%;
  width: 125.37vh;
  & > div {
    height: 100%;
  }
  .left-wrap {
    .land-image,
    img {
      width: 100%;
      height: 100%;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
    }
  }

  .right-wrap {
    display: flex;
    align-items: center;
    justify-content: center;

    .auth-form-box {
      width: 420px;
      box-sizing: border-box;
      height: 100%;
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .land-title-box {
        .land-title {
          margin-bottom: 5.33vh;

          .land-logo {
            width: 44px;
            height: 44px;
            background-color: #2e9adb;
            border-radius: 50%;
            margin-right: 16px;
          }

          .text-main {
            margin-top: 0;
          }
          &.main-title {
            cursor: pointer;
            .text-main {
              font-size: 34px;
            }
          }
        }

        .text-main {
          letter-spacing: 4px;
          text-align: center;
          font-size: 2rem;
          color: #333333;
          font-weight: 600;
        }
      }

      .form-wrap ::v-deep {
        .form-item {
          ::-webkit-input-placeholder {
            color: #999999;
          }
          .el-input__inner {
            background-color: #f3f3f3;
            border: none;
          }
          margin-bottom: 2.23vh;

          &.vcode-item {
            .el-form-item__content {
              display: flex;
            }
          }

          .el-input__inner {
            height: 48px;
            line-height: 48px;
          }

          .vcode-btn {
            width: 88px;
            height: 48px;
            margin-left: 12px;
            background: #e4f0ff;
            border-radius: 6px;
            color: #2e9adb;
            padding: 10px 4px;
            border-color: transparent;
            transition: width 200ms ease-in-out;
            &.biger {
              width: 120px;
            }
          }
        }
      }

      .foot-wrap ::v-deep {
        margin-top: 2.22vh;

        .submit-btn {
          width: 100%;
          height: 48px;
          background: #2e9adb;
          border-radius: 6px;
        }

        .form-bottom {
          margin-top: 12px;

          span {
            font-size: 14px;
            color: #333333;

            &.web-link {
              cursor: pointer;
              &:hover {
                color: #2e9adb;
              }
              &.active {
                color: #2e9adb;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-height: 899px) {
  .land-box
    .right-wrap
    .auth-form-box
    .land-title-box.compact-layout
    .land-title {
    margin-bottom: 3vh;
  }
}
</style>
